/* eslint-disable react/prop-types */
import React, { useRef, useState } from 'react';
import TooltipDropdown from './TooltipDropdown.tsx';
import { useOutsideClick } from '../../redesign/hooks/useOutsideClick.ts';

const MegaMenuLanguages = ({ languagesExpandedValue }) => {
  const [showLanguages, setShowLanguages] = useState(false);

  const ref = useRef(null);
  useOutsideClick(ref, () => setShowLanguages(false));

  if (!languagesExpandedValue) {
    return null;
  }

  const currentHostname = window.location.hostname;
  const currentLang =
    languagesExpandedValue.find(x =>
      x.urlSegment?.value?.includes(currentHostname)
    ) ?? languagesExpandedValue[0];
  const url = new URL(window.location.href);

  const buildLink = (currentUrl, languageValue) => {
    if (!languageValue?.urlSegment?.value) {
      return currentUrl.toString();
    }

    const result = new URL(currentUrl);
    result.hostname = languageValue.urlSegment.value;
    return result.toString();
  };

  return (
    <div className='mega-menu-language__selector-container' ref={ref}>
      <button
        className="mega-menu-language__selector-button"
        onClick={() => setShowLanguages(old => !old)}
      >
        <div className="mega-menu-language__selector-icon-container">
          <svg role="presentation">
            <use xlinkHref="#globe-icon" />
          </svg>
        </div>
        {currentLang?.display?.value}
      </button>
      <TooltipDropdown
        open={showLanguages}
        content={
          <ul className='mega-menu-language__dropdown'>
            {languagesExpandedValue
              .filter(x => x !== currentLang)
              .map(x => (
                <li key={x?.urlSegment?.value}>
                  <a href={buildLink(url, x)}>{x?.display?.value}</a>
                </li>
              ))}
          </ul>
        }
      />
    </div>
  );
};

export default MegaMenuLanguages;
